import React from "react";

// MUI Imports
import TableBody from "@mui/material/TableBody";

// Component Imports
import SelfOptOutRow from "./SelfOptOutRow";
import { formatDate } from "../../../Helpers/formatters";

const SelfOptOutTableBody = ({
  selfOptOutData,
  selectForBulk,
  selectAll
}) => {

  const selfOptOuts = selfOptOutData?.sort((a, b) => {
    return formatDate(b.createdDate) > formatDate(a.createdDate)
  });

  return (
    <TableBody className="table-background-color">
      {selfOptOuts?.map((selfoptoutItem, idx) => (
        <SelfOptOutRow
          key={idx}
          idx={idx}
          row={selfoptoutItem}
          selectForBulk={selectForBulk}
          selectAll={selectAll}
        />
      ))}
    </TableBody>
  );
};

export default SelfOptOutTableBody;
